export enum MonetizationEventsEventType {
  SPORTS = 'SPORTS',
  METAGAMES = 'METAGAMES',
}

export interface SportMetadata {
  id: string;
  status: string;
  homeScore: number;
  awayScore: number;
  sideAImageUrl: string;
  sideBImageUrl: string;
  gameClock: string | null;
  startDate: string;
}

export interface UserMonetizationEvent<TMetadata = unknown> {
  id: string;
  userId: string;
  eventId: string;
  gameId: number;
  widgetImageUrl: string;
  providerType: string;
  gameNameType: string;
  manualOptIn: boolean;
  optInDate: string | null;
  balance: number;
  startDate: Date;
  endDate: Date;
  displayPopup: boolean;
  metadata?: TMetadata;
}

// Type alias for sports events with SportMetadata
export type SportMonetizationEvent = UserMonetizationEvent<SportMetadata>;

export interface MonetizationEventsResponse {
  monetizationEvents: UserMonetizationEvent[];
}

export interface MonetizationEventsCurrentEvent<TMetadata = unknown> extends UserMonetizationEvent<TMetadata> {
  url?: string;
  token?: string;
  path?: string;
}

// Type alias for sports current events with SportMetadata
export type SportMonetizationCurrentEvent = MonetizationEventsCurrentEvent<SportMetadata>;

export const isSportMonetizationCurrentEvent = (
  event: MonetizationEventsCurrentEvent,
): event is SportMonetizationCurrentEvent => {
  return event.providerType === MonetizationEventsEventType.SPORTS;
};
